import { MenuItem, MenuGroup, MenuItemTitle } from "elseware-ui";

import {
  FaYoutube,
  FaMedium,
  FaChalkboardTeacher,
  FaBook,
  FaCertificate,
  FaCode,
  FaGamepad,
  FaBriefcase,
  FaHeart,
  FaFlask,
} from "react-icons/fa";

const header_nav_mobile = [
  // {
  //   component: MenuGroup,
  //   name: "Content",
  //   items: [
  //     {
  //       component: MenuItem,
  //       name: "YouTube",
  //       to: "/content/youtube",
  //       icon: <FaYoutube />,
  //       description: "Watch my tutorials (SimpleEPIC)",
  //     },
  //     {
  //       component: MenuItem,
  //       name: "Medium",
  //       to: "/content/medium",
  //       icon: <FaMedium />,
  //       description: "Read my technical Blogs"
  //     },
  //     {
  //       component: MenuItem,
  //       name: "Workshops",
  //       to: "/content/workshops",
  //       icon: <FaChalkboardTeacher />,
  //       description: "Check out my workshops & Techtalks"
  //     },
  //   ],
  // },
  {
    component: MenuGroup,
    name: "Education",
    items: [
      {
        component: MenuItem,
        name: "Academics",
        to: "/education/academics",
        icon: <FaBook />,
        description: "Explore my academic background and studies.",
      },
      {
        component: MenuItem,
        name: "Certifications",
        to: "/education/certifications",
        icon: <FaCertificate />,
        description: "Discover my certifications and achievements.",
      },
    ],
  },
  {
    component: MenuGroup,
    name: "Projects",
    items: [
      {
        component: MenuItem,
        name: "Software",
        to: "/projects/software",
        icon: <FaCode />,
        description: "Check out my software projects",
      },
      {
        component: MenuItem,
        name: "Game",
        to: "/projects/game",
        icon: <FaGamepad />,
        description: "Developed games & subsystems (UE)",
      },
    ],
  },
  {
    component: MenuItem,
    name: "Experience",
    to: "/experience",
    // icon: <FaBriefcase />,
  },
  {
    component: MenuItem,
    name: "Lifestyle",
    to: "/lifestyle",
    // icon: <FaHeart />,
  },
  {
    component: MenuItem,
    name: "Research",
    to: "/research",
    // icon: <FaFlask />,
  },
];

export default header_nav_mobile;
